import { render, staticRenderFns } from "./SurveysList.vue?vue&type=template&id=6e0938c4"
import script from "./SurveysList.vue?vue&type=script&lang=js"
export * from "./SurveysList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports